import React, { FC, useCallback } from 'react';
import { Redirect, Route, withRouter } from 'react-router';
import { connect } from 'react-redux';
import OverviewShell from '../overview_shell/OverviewShell';

const ToolsOverviewPage: FC<any> = ({ history, childRoutes }): React.ReactElement => {
	const handleTabChange = useCallback(
		(key) => history.push(`/supplier/tools/overview/${key}`),
		[history]
	);

	const checkTabActive = useCallback(
		(key) => {
			const pathname = history.location.pathname;
			return pathname.indexOf(key) !== -1;
		},
		[history.location.pathname]
	);

	const tabs = [
		{
			key: 'all',
			name: 'All Tools',
		},
		{
			key: 'myPickups',
			name: 'My Pick Ups',
		},
	];

	return (
		<>
			<Route
				path="/supplier/tools/overview"
				exact={true}
				render={() => (
					<Redirect
						to={{
							pathname: '/supplier/tools/overview/all',
						}}
					/>
				)}
			/>
			<OverviewShell
				title="Tools"
				tabs={tabs}
				onTabChange={handleTabChange}
				checkTabActive={checkTabActive}
				childRoutes={childRoutes}
				className="toolsPage"
			/>
		</>
	);
};

const mapStateToProps = (state, ownProps) => ({});
const mapDispatchToProps = (dispatch) => ({});

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(ToolsOverviewPage));
